import { Fragment } from "react";
import classes from "./NotificationAlert.module.css";

function NotificationAlert(props) {
  const alertType = props.alertType;
  const alertTitle = props.alertTitle;
  const alertDescription = props.alertDescription;

  let alert = "";
  if (alertType === "error") {
    alert = classes.error;
  }
  if (alertType === "info") {
    alert = classes.info;
  }
  if (alertType === "warning") {
    alert = classes.warning;
  }
  if (alertType === "success") {
    alert = classes.success;
  }
  return (
    <Fragment>
      <div className={`${classes.note2} ${alert}`}>
        <div>
          <h4>{alertTitle}</h4>
          <p>{alertDescription}</p>
        </div>
      </div>
    </Fragment>
  );
}

export default NotificationAlert;
